'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPlaylistAdd = function MdPlaylistAdd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.4 26.6v-3.2h13.2v3.2h-13.2z m26.6-3.2h6.6v3.2h-6.6v6.8h-3.4v-6.8h-6.6v-3.2h6.6v-6.8h3.4v6.8z m-6.6-13.4v3.4h-20v-3.4h20z m0 6.6v3.4h-20v-3.4h20z' })
        )
    );
};

exports.default = MdPlaylistAdd;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/playlist-add.js
// module id = 2670
// module chunks = 0